import { Tooltip } from '@chegg-ui/tooltip'
import { FC } from 'react'
import {
  ItemContainer,
  ListItem,
  ListItemPaperStatus,
  ListItemPaperTitle,
  TooltipText,
} from '../styled'

interface Props {
  isActive: boolean
  title: string
  status: string
  onClick: () => void
  isPaperCheckInProgress: boolean
}

export const PapersListItem: FC<Props> = ({
  isActive,
  title,
  status,
  onClick,
  isPaperCheckInProgress,
}) => {
  return (
    <ListItem
      onClick={onClick}
      isActive={isActive}
      isPaperCheckInProgress={isPaperCheckInProgress}
    >
      <ItemContainer>
        <Tooltip
          position="topRight"
          targetElement={<ListItemPaperTitle>{title}</ListItemPaperTitle>}
        >
          <TooltipText>{title}</TooltipText>
        </Tooltip>

        <ListItemPaperStatus>{status}</ListItemPaperStatus>
      </ItemContainer>
    </ListItem>
  )
}
